import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useNavigationPrompt } from '../NavigationPromptProvider'

export function usePrompt(shouldBlock) {
  const history = useHistory()
  const { confirmAction } = useNavigationPrompt()

  useEffect(() => {
    if (!shouldBlock) return

    const unblock = history.block((tx) => {
      confirmAction(tx.pathname, () => {
        unblock()
        history.push(tx.pathname)
      })
      return false
    })

    return unblock
  }, [shouldBlock, confirmAction, history])
}
